import React from 'react';
import '@style/counter.css';
import { removeNonNumeric } from '@helper';
const Counter = ({ onChange, stockAmount, value, increase, decrease }) => {
    return (
        <div className="spinner mx-auto">
            <button
                type="button"
                disabled={parseInt(value) <= 0}
                className={`decrease ${parseInt(value) <= 0 ? 'disable' : ''}`}
                onClick={() => {
                    decrease();
                }}
            >
                -
            </button>
            <input
                className="value"
                value={removeNonNumeric(value)}
                onChange={onChange}
            />
            <button
                type="button"
                disabled={parseInt(value) >= stockAmount}
                className={`increase ${
                    parseInt(value) >= stockAmount ? 'disable' : ''
                }`}
                onClick={() => {
                    increase();
                }}
            >
                +
            </button>
        </div>
    );
};

export default Counter;
